import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Badge, Group, Stack, Table, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconPower } from '@tabler/icons-react';

import { useDeactivateAccount } from '../api/deactivateAccount';
import { accountTypes } from '../types';

import { AccountModal } from './AccountModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { useAccount } from '@/features/auth';
import { COLORS } from '@/utils/colors';

type Props = {
  account: accountTypes.Account;
  rolesMap: Map<string, string>;
  colorsMap: Map<string, string>;
};

export const AccountRow = ({ account, rolesMap, colorsMap }: Props) => {
  const deactivateAccountMutation = useDeactivateAccount();
  const { data: accountData } = useAccount();
  const isOwnAccount = accountData?.account._id === account._id;

  return (
    <Table.Tr>
      <Table.Td>
        <Text fw={500}>{account.username}</Text>
      </Table.Td>
      <Table.Td>
        <Stack gap={4}>
          {(account.roleIds ?? []).length === 0 ? (
            <Text size="sm" c="dimmed">
              —
            </Text>
          ) : (
            (account.roleIds ?? []).map((roleId) => (
              <Badge
                key={roleId}
                color={colorsMap.get(roleId)}
                variant="light"
                radius="sm"
                size="sm"
              >
                {rolesMap.get(roleId) ?? roleId}
              </Badge>
            ))
          )}
        </Stack>
      </Table.Td>
      <Table.Td>
        <Group gap="xs" justify="right">
          <Tooltip label="Edit roles">
            <ActionIcon
              variant="filled"
              radius="md"
              onClick={() => NiceModal.show(AccountModal, { account })}
              aria-label="Edit account roles"
            >
              <IconEdit color={COLORS.text} />
            </ActionIcon>
          </Tooltip>
          <Tooltip
            label={isOwnAccount ? 'You cannot deactivate your own account' : 'Deactivate account'}
          >
            <ActionIcon
              variant="filled"
              color="red"
              radius="md"
              aria-label="Deactivate account"
              disabled={isOwnAccount}
              onClick={() =>
                NiceModal.show(ConfirmModal, {
                  title: `Deactivate account (${account.username})?`,
                  onSuccess: () => deactivateAccountMutation.mutate({ id: account._id }),
                })
              }
            >
              <IconPower color={COLORS.text} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
